module.exports = __webpack_public_path__ + "static/media/hk.30efd8ef.svg";